import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import swal from 'sweetalert'
import Select from 'react-select'
import PageLoader from '../../components/PageLoader/PageLoader'
import Paginate from '../../components/pagination/paginate'
import { appDeleteSponsor, appGetAllSponsor } from '../../store/sponsor'
import { appGetAllSanstha } from '../../store/sanstha'
import PostPreview from '../../components/PostPreview/PostPreview'
import { toCamelCase } from '../../utils/Function'

function TableFilter() {
	const dispatch = useDispatch()
	const params = useParams()
	const navigate = useNavigate()
	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')
	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')
	const isloder = useSelector(state => state?.sponsorReducer.isloder)
	const paginate = useSelector(state => state.sponsorReducer.paginate)
	const isdeleted = useSelector(state => state?.sponsorReducer?.isdeleted)
	const sponsor = useSelector(state => state?.sponsorReducer.sponsor)
	const [page, setPage] = useState(params.page || 1)

	useEffect(() => {
		if (isdeleted) {
			dispatch(
				appGetAllSponsor({
					page,
					limit: 10,
					admin: true,
					sanstha: sansthaId || permissionOfSanstha,
				}),
			)
		}
	}, [isdeleted, dispatch])

	const handleDeleteSponsor = id => {
		swal({
			title: 'Are you sure?',
			text: 'You want to delete this sponsor?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willDelete => {
			if (willDelete) {
				dispatch(appDeleteSponsor(id))
			}
		})
	}

	useEffect(() => {
		dispatch(
			appGetAllSponsor({
				page,
				limit: 10,
				admin: true,
				// hub: hubId || permissionOfHub,
				sanstha: sansthaId || permissionOfSanstha,
			}),
		)
		navigate(`/sponsor/${page}`)
	}, [page])

	return (
		<>
			{isloder && <PageLoader />}
			<div className="card dataTables_wrapper">
				<div className="card-body">
					<div className="table-responsive bootgrid mt-3">
						<table className="table table-hover" id="bootgrid-command">
							<thead>
								<tr>
									<th>Sponsor Image</th>
									<th>Sponsor Name</th>
									<th data-column-id="received" data-order="desc">
										Sanstha
									</th>
									<th data-column-id="received" data-order="desc">
										Community
									</th>
									<th data-column-id="received" data-order="desc">
										Paid Amount (Rs)
									</th>
								</tr>
							</thead>
							<tbody>
								{sponsor &&
									sponsor.map((value, index) => (
										<tr key={index}>
											<td>
												<PostPreview value={value.image} />
											</td>
											<td>
												<PostPreview value={value?.user?.profilePic || '/img/user.jpg'} />

												{value?.user?.firstName}
												{value?.user?.lastName}
											</td>
											<td>
												<PostPreview value={value?.sanstha?.image} />
												{toCamelCase(value?.sanstha?.name)}
											</td>
											<td>
												<PostPreview value={value?.hub?.image} />
												{toCamelCase(value?.hub?.name)}
											</td>
											<td>{value?.amount || 0}</td>
											<td>
												<button
													type="button"
													className="btn btn-sm btn-info mr-2 command-edit"
													onClick={() => navigate(`/sponsor/edit/${value?._id}`)}
												>
													<em className="fa fa-edit fa-fw"></em>
												</button>

												<button
													type="button"
													className="btn btn-sm btn-danger command-delete"
													onClick={() => handleDeleteSponsor(value?._id)}
												>
													<em className="fa fa-trash fa-fw"></em>
												</button>
											</td>
										</tr>
									))}
							</tbody>
						</table>
					</div>
					{paginate && <Paginate paginate={paginate} page={page} setPage={setPage} />}
				</div>
			</div>
		</>
	)
}

export default TableFilter
